import React from 'react'

export interface IconPerthNowThumbnailPNProps {
    className?: string
    fillColor?: string
}

export const IconPerthNowThumbnailPN: React.FC<IconPerthNowThumbnailPNProps> =
    ({ className, fillColor = '#666869' }) => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className={className}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.2364 6.28768H13.5046V17.7895H16.3801V11.5113C16.3801 9.97782 17.1232 8.58778 19.016 8.58778C21.0289 8.58778 21.1248 10.6964 21.1248 11.9667V17.7895H24V10.5286C24 8.1807 22.8976 6 19.8066 6C17.8896 6 16.8112 6.9827 16.2845 8.13262H16.2364V6.28768ZM2.86571 12.1741C2.86571 14.0253 4.38308 15.5261 6.25517 15.5261C7.4045 15.5261 8.41826 14.9594 9.03131 14.0939C9.40154 13.5162 9.60189 12.8256 9.60189 12.1097C9.60189 11.7715 9.55697 11.4384 9.47095 11.1194C9.02369 9.78511 7.75485 8.82045 6.25517 8.82045C4.38308 8.82045 2.86571 10.3221 2.86571 12.1741ZM0.0138834 12.1741C0.0138834 8.76373 2.80826 6.00005 6.25489 6.00005C9.70207 6.00005 12.4962 8.76373 12.4962 12.1741C12.4962 15.5837 9.70207 18.3476 6.25489 18.3476C5.01682 18.3476 3.86613 17.9864 2.89538 17.3705V21.7726H0V12.2885L0.018239 12.2601C0.018239 12.2459 0.0171653 12.2318 0.016084 12.2177C0.0149876 12.2034 0.0138834 12.189 0.0138834 12.1741Z"
                    fill={fillColor}
                />
            </svg>
        )
    }
